const ROLES = {
  ADMIN: 1566,
  USER: 2000,
  TUTOR: 5777,
};

export default ROLES;
